import React, { useContext } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import UserContext from 'components/context/UserContext';
import {
    companyDomainEmailTooltip,
    isCompanyDomainEmail,
} from 'utils/customer/CompanyDomainEmail';

const useStyles = makeStyles((theme) => ({
    emailFieldContainer: {
        position: 'relative',
        width: '100%',
    },
    emailFieldWithIcon: {
        paddingRight: theme.spacing(4),
    },
    emailWarningIconWrapper: {
        position: 'absolute',
        right: theme.spacing(1),
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 0,
    },
    emailWarningIcon: {
        color: theme.palette.warning.main,
        fontSize: 20,
    },
}));

const CompanyDomainEmailInput = ({
    value,
    onChange,
    className,
    ...formControlProps
}) => {
    const classes = useStyles();
    const { userInformation = {} } = useContext(UserContext);
    const showWarning = isCompanyDomainEmail(value, userInformation.companyListDomain);

    return (
        <div className={classes.emailFieldContainer}>
            <Form.Control
                type="text"
                size="sm"
                value={value || ''}
                onChange={onChange}
                className={clsx(className, showWarning && classes.emailFieldWithIcon)}
                {...formControlProps}
            />
            {showWarning && (
                <Tooltip title={companyDomainEmailTooltip} placement="top">
                    <span className={classes.emailWarningIconWrapper}>
                        <WarningRoundedIcon className={classes.emailWarningIcon} />
                    </span>
                </Tooltip>
            )}
        </div>
    );
};

CompanyDomainEmailInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};

CompanyDomainEmailInput.defaultProps = {
    value: '',
    className: '',
};

export default CompanyDomainEmailInput;
